'use strict';

var React = require('react');

var SvgMetaobjectListIcon = function SvgMetaobjectListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 5v-1.5c0-.552-.448-1-1-1h-2.5c-.552 0-1 .448-1 1v1.5h-.5c-.552 0-1 .448-1 1v3.5h-1.5v-1.5c0-.552-.448-1-1-1h-2.5c-.552 0-1 .448-1 1v1.5h-.5c-.552 0-1 .448-1 1v4.75c0 .552.448 1 1 1h6.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-6.25v-3.75h12v.25c0 .414.336.75.75.75s.75-.336.75-.75v-5.25c0-.552-.448-1-1-1h-.5Zm-1.5 0v-1h-1.5v1h1.5Zm-3 1.5v3h4.5v-3h-4.5Zm-4.5 3h-1.5v-1h1.5v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 13.75c0-.414.336-.75.75-.75h4.75c.414 0 .75.336.75.75s-.336.75-.75.75h-4.75c-.414 0-.75-.336-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16c-.414 0-.75.336-.75.75s.336.75.75.75h4.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.75Z"
  }));
};
SvgMetaobjectListIcon.displayName = "MetaobjectListIcon";

exports.SvgMetaobjectListIcon = SvgMetaobjectListIcon;
